import { useEffect, useState } from "react";

const TOUCH_MEDIA_QUERY = "(hover: none), (pointer: coarse)";

export function prefersTouchInteraction(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  return window.matchMedia(TOUCH_MEDIA_QUERY).matches;
}

/** True, gdy głównym sposobem interakcji jest dotyk (brak hovera / gruby wskaźnik). */
export function usePrefersTouch(): boolean {
  const [prefersTouch, setPrefersTouch] = useState(prefersTouchInteraction);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(TOUCH_MEDIA_QUERY);
    const onChange = () => setPrefersTouch(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return prefersTouch;
}
